import React from "react";
import {
  Drawer,
  Tabs,
  Collapse,
  Row,
  Col,
  Steps,
  Skeleton,
  Popover,
} from "antd";
import { isEmpty } from "lodash-es";
import moment from "moment";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import EvaluationTable from "views/Email/Includes/EmployeeEvaluationTable";

const ReviewTemplateTablePresentation = ({
  openProfileDrawer,
  closeProfileDrawer,
  data,
}) => {
  // const filterUserForm = data?.employeeEvaluationParticipantDetailsDTOs.filter(
  //   (participant) => participant.participantType === 1
  // );

  //console.log("ReviewTemplateTablePresentation data", data);

  if (!data || !data.employeeEvaluationParticipantDetailsDTOs) {
    // Data is not available or doesn't have the expected structure
    return <p></p>;
  }

  const filterUserForm = data.employeeEvaluationParticipantDetailsDTOs.filter(
    (participant) => participant.participantType === 0
  );

  const ProfileReviewPresentationComponent = () => {
    return (
      <>
        <Drawer
          title="Profile Review"
          placement="right"
          visible={openProfileDrawer}
          onClose={closeProfileDrawer}
          width={720}
          className="approval-form-wrapper"
        >
          <Steps
            current={
              data
                ? data?.employeeEvaluationStatus?.displayName === "Apply"
                  ? 1
                  : data?.employeeEvaluationStatus?.displayName ===
                    "SupervisorApproved"
                  ? 2
                  : 3
                : 1
            }
          >
            <Steps.Step title="Request" />
            <Steps.Step title="Reviewed" />
            <Steps.Step title="Complete" />
          </Steps>
          <Collapse accordion>
            <div className="mail-leave-details">
              <div className="leave-details">
                <Row gutter={20}>
                  <Col lg={12} className="leave-col">
                    <div className="leave-input">Name</div>
                    <div className="leave-input">Job Title</div>
                    <div className="leave-input">Department</div>
                    <div className="leave-input">Username</div>
                    <div className="leave-input">Date</div>
                    <div className="leave-input">Supervisor</div>
                    <div className="leave-input">Review Date (in days)=</div>
                  </Col>
                  <Col lg={12} className="leave-col">
                    <div className="leave-input">{data?.name}</div>
                    <div className="leave-input">{data?.jobTitle}</div>
                    <div className="leave-input">{data?.department}</div>
                    <div className="leave-input">{data?.employeeInitials}</div>
                    <div className="leave-input">
                      {moment(data?.date).format("YYYY-MM-DD")}
                    </div>
                    <div className="leave-input">
                      {data?.immidiateSuperior.join(", ")}
                    </div>
                    <div className="leave-input">{data?.reviewPeriod}</div>
                  </Col>
                </Row>
              </div>
            </div>
          </Collapse>
          <section></section>

          <Tabs type="card" style={{ margin: "10px 10px" }}>
            {filterUserForm?.map((tab, tabIndex) => (
              <Tabs.TabPane
                tab={`${tab?.participantUser?.username}`}
                key={String(tabIndex + 1)}
              >
                <div className="mail-leave-details">
                  <div className="leave-details" style={{ margin: "0px 0px" }}>
                    <EvaluationTable participantEmployeeEvaluationForm={tab} />
                  </div>
                </div>
              </Tabs.TabPane>
            ))}
          </Tabs>
        </Drawer>
      </>
    );
  };

  return data ? ProfileReviewPresentationComponent() : <Skeleton active />;
};

export default ReviewTemplateTablePresentation;
